import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  fetchingOrdersInfoForAnalytics: true,
  ordersDetails: null,
  fetchingTopCommodities: false,
  topCommodities: [],
  fetchingTopPackages: false,
  topPackages: [],
  fetchingTATDetailsPackage: false,
  avgTATPackage: [],
  fetchingTATDetailsCommodity: false,
  avgTATCommodity: [],
  companyUsers: null,
};

const analyticsDashboardSlice = createSlice({
  name: "analyticsDashboard",
  initialState,
  reducers: {
    fetchOrdersInfoForAnalytics(state, action) {
      state.fetchingOrdersInfoForAnalytics = true;
    },
    fetchOrdersInfoForAnalyticsSuccess(state, action) {
      state.fetchingOrdersInfoForAnalytics = false;
      state.ordersDetails = action.payload.data.document;
    },
    fetchOrdersInfoForAnalyticsFailure(state, action) {
      state.fetchingOrdersInfoForAnalytics = false;
    },
    fetchTopCommodities(state, action) {
      state.fetchingTopCommodities = true;
    },
    fetchTopCommoditiesSuccess(state, action) {
      state.fetchingTopCommodities = false;
      state.topCommodities = action.payload.data.document;
    },
    fetchTopCommoditiesFailure(state, action) {
      state.fetchingTopCommodities = false;
    },
    fetchTopPackages(state, action) {
      state.fetchingTopPackages = true;
    },
    fetchTopPackagesSuccess(state, action) {
      state.fetchingTopPackages = false;
      state.topPackages = action.payload.data.document;
    },
    fetchTopPackagesFailure(state, action) {
      state.fetchingTopPackages = false;
    },
    fetchTATDetailsPackage(state, action) {
      state.fetchingTATDetailsPackage = true;
    },
    fetchTATDetailsPackageSuccess(state, action) {
      state.fetchingTATDetailsPackage = false;
      state.avgTATPackage = action.payload.data.document;
    },
    fetchTATDetailsPackageFailure(state, action) {
      state.fetchingTATDetailsPackage = false;
    },
    fetchTATDetailsCommodity(state, action) {
      state.fetchingTATDetailsCommodity = true;
    },
    fetchTATDetailsCommoditySuccess(state, action) {
      state.fetchingTATDetailsCommodity = false;
      state.avgTATCommodity = action.payload.data.document;
    },
    fetchTATDetailsCommodityFailure(state, action) {
      state.fetchingTATDetailsCommodity = false;
    },
    fetchCompanyUsers(state, action) {
      state.loading = true;
    },
    fetchCompanyUsersSuccess(state, action) {
      state.companyUsers = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyUsersFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = analyticsDashboardSlice;
